import { z } from "zod";

export const checkInSchema = z.object({
  ids: z
    .array(z.string())
    .min(1, 'Мінімум один працівник обов\'язковий'),
});

export type CheckInInfoFormScheme = z.infer<typeof checkInSchema>;
